import * as React from "react";
import TemplatePage from "./Pages/TemplatePage";

const App: React.FC = () => {

    return (
      <>
        <TemplatePage/>
      </>
    );
};
export default App;
